import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, Grid2, IconButton, TextField, useTheme } from '@mui/material';
import { Formik } from 'formik';
import * as React from 'react';
import { IoMdClose } from 'react-icons/io';
import { useUpdateWorkFlowNcrMutation } from 'store/slices/apis/keyNcrSlice';
import * as Yup from 'yup';

export default function RejectNcrComponent(props) {
    const { open, cancel, rowData, openNotification,refetch } = props;
    const theme = useTheme();
    const [updateWorFlowNcr, updateWorkFlowNcrRes] = useUpdateWorkFlowNcrMutation();
    const [formData, setFormData] = React.useState({
        Comment: '',
        Status: 'Reject',
        Type: 'Ncr',

    })

    const handleSubmit = (values) => {
        
        updateWorFlowNcr({ ...values, ParentId: rowData?.id, data: JSON?.stringify(rowData) })
    }


    React.useEffect(() => {
        if (updateWorkFlowNcrRes?.isSuccess) {
            if (updateWorkFlowNcrRes?.data?.status == 'Success') {
                openNotification(updateWorkFlowNcrRes?.data?.message, 'success')
                cancel();
                refetch()
            } else {
                openNotification(updateWorkFlowNcrRes?.data?.message, 'error')
            }
        }
    }, [updateWorkFlowNcrRes?.isSuccess]);

    const validationSchema = Yup.object({
        Comment: Yup.string().required("Comment field is required."),
    });

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={cancel}
                disableEnforceFocus
                disableRestoreFocus
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitle sx={{ fontWeight: 500, fontSize: '20px', color: '#252525', paddingBottom: 0 }} id="draggable-dialog-title">
                    Reject
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <DialogContent>
                    <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747' }}>
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                                <form onSubmit={handleSubmit}>

                                    <Grid2 size={12}>
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Comment"
                                            name="Comment"
                                            multiline
                                            fullWidth
                                            rows={3}
                                            value={values?.Comment}
                                            onChange={handleChange}
                                            onBlur={() => setTouched({ ...touched, Comment: true })}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            variant="filled"
                                            sx={{
                                                "& .MuiInputLabel-root.Mui-focused": {
                                                  color: "#696969",
                                                  fontSize: "14px",
                                                },
                                              }}
                                        />
                                        {touched?.Comment && errors?.Comment &&
                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Comment}`}</FormHelperText>
                                        }
                                    </Grid2>

                                    <Grid2 size={12}>
                                        <DialogActions>
                                            {/* <Button variant="outlined" onClick={cancel} sx={{
                                                color: '#415385',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                textTransform: 'none',
                                                border: '1px solid #415385'
                                            }}>Cancel</Button> */}
                                            <Button type='submit' loading={updateWorkFlowNcrRes?.isLoading} variant="contained" sx={{
                                                backgroundColor: '#C52A1A',
                                                color: '#fff',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                textTransform: 'none'
                                            }}>
                                                Reject
                                            </Button>
                                        </DialogActions>
                                    </Grid2>
                                </form>
                            )}
                        </Formik>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}